import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./Pages/Main.js";
import CompanyPage from "./Pages/CompanyPage.js";
import Privacy from "./Pages/Privacy.js";
import VisitorTracker from "./Components/VisitorTracker.js";

function App() {
  return (
    <BrowserRouter>
      <VisitorTracker />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/:companySlug" element={<CompanyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
